// Money formatting helpers — MXN primary, USD shown as "USD$1,840".
// Compact form gated by the `compact` flag for the densest views.
//
// Mirrors gastos-v2/primitives.jsx fmtMoney + toMXN.

export type Currency = 'MXN' | 'USD';

/** Working-rate fallback for USD → MXN conversions. Production reads
 *  the live rate from `settings.fx_usd_mxn`; this constant is the
 *  fallback when settings hasn't loaded yet or doesn't have one set. */
export const FX_USD_MXN_FALLBACK = 17.4;

export function fmtMoney(
  n: number,
  currency: Currency = 'MXN',
  { compact = false }: { compact?: boolean } = {},
): string {
  const sym = currency === 'USD' ? 'USD$' : '$';
  if (!Number.isFinite(n)) return `${sym}—`;
  if (compact && n >= 10000) {
    if (n >= 1000000) return `${sym}${(n / 1000000).toFixed(1)}M`;
    return `${sym}${(n / 1000).toFixed(n >= 100000 ? 0 : 1)}k`;
  }
  return sym + n.toLocaleString('es-MX', { maximumFractionDigits: 0 });
}

export function toMXN(amount: number, currency: Currency, fxUsdMxn = FX_USD_MXN_FALLBACK): number {
  return currency === 'USD' ? Math.round(amount * fxUsdMxn) : amount;
}
